export const createApiKeysRequests = (client) => ({
    generateExternalApiKey: async (payload) => {
        const { data } = await client.axios.post("/api_keys/external", { contests_edition_id: payload.contestsEditionId });
        if (typeof data?.data?.id !== "string" || typeof data?.meta?.value !== "string") {
            throw new Error("External API key generation returned an invalid response");
        }
        return { id: data.data.id, value: data.meta.value };
    },
});
//# sourceMappingURL=index.js.map